<template>
  <div class="body">
    <el-card class="card" shadow="never">
      <div class="header">
        <h3>{{ $t("navbar.email") }}</h3>
      </div>

      <div class="main">
        <div class="left">
          <div v-if="!isshow">
            <img :src="posterUrl" style="max-width: 378px" />
          </div>
          <!--    邮箱邀请函   width: 0; height: 0    -->
          <div style="overflow: hidden; width: 0; height: 0">
            <!-- width:0;height:0; -->
            <div id="email" ref="email" class="email">
              <div class="head">
                <img
                  alt=""
                  src="../../static/头图en.png"
                  v-if="$i18n.locale == 'en'"
                />
                <img alt="" src="../../static/头图.png" v-else />

                <!-- <p>{{$t('emailInvite.title')}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{$t('emailInvite.time')}}</p> -->
              </div>
              <div class="content">
                <!-- <div class="logo">
                  <img  :src="baseUrl+img" />
                  <div style="display: flex;flex-direction: column;justify-content: space-between">
                    <p>{{ companyName }}</p>
                    <p>
                      {{$t('emailInvite.invite')}} <br />
                       {{$t('emailInvite.exName')}}
                    </p>
                  </div>
                </div> -->

                <p style="margin-top: 0px; font-size: 14px; font-weight: 600">
                  {{ $t("emailInvite.client") }}
                </p>

                <p style="font-size: 16px; margin-top: 18px; line-height: 28px">
                  {{ $t("emailInvite.content") }}
                  <!-- <span style="color: #0772b9">
                    {{ $t("emailInvite.exName") }}</span
                  > -->
                  {{ $t("emailInvite.content2") }}
                </p>

                <!-- 中间卡片地方 -->
                <div
                  class="exhibitor"
                  style="width: 600px; height: 200px; margin-top: 32px"
                >
                  <div class="company">
                    <div class="companyimg">
                      <img :src="img" alt="" crossOrigin="anonymous" />
                    </div>
                    <div class="companyName">
                      <h2>{{ companyName }}</h2>
                      <h4>展位号</h4>
                      <div
                        style="
                          width: 100%;
                          display: flex;
                          flex-direction: row;
                          justify-content: space-around;
                          font-size: 15px;
                        "
                      >
                        <div
                          style="
                            color: #0772b9;
                            display: flex;
                            flex-direction: row;
                            justify-content: space-around;
                            align-items: center;
                            margin-right: 10px;
                          "
                        >
                          <img
                            src="../../static/jiantou_qiehuan.png"
                            style="transform: scale(-1,1);width:27px;height:30px;content"
                            alt=""
                          />
                          公司介绍
                        </div>
                        <div
                          style="
                            display: flex;
                            justify-content: space-around;
                            align-items: center;
                            margin-right: 10px;
                          "
                        >
                          <img
                            src="../../static/jiantou_qiehuan.png"
                            style="transform: scale(-1,1);width:27px;height:30px;content"
                            alt=""
                          />
                          主营产品
                        </div>
                        <div
                          style="
                            display: flex;
                            justify-content: space-around;
                            align-items: center;
                            margin-right: 10px;
                          "
                        >
                          <img
                            src="../../static/jiantou_qiehuan.png"
                            style="transform: scale(-1,1);width:27px;height:30px;content"
                            alt=""
                          />
                          现场活动
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="xinguan">
                    <!-- <div class="pavilion">
                      <h4>北京 中国国际展览中心（新馆）</h4>
                      <p>2023年10月25-28日</p>
                    </div> -->
                    <!-- <div class="exhi">
                      <p>展位</p>
                    </div>
                    <div class="exhiNum">
                    </div> -->
                    <div class="subscribe">
                      <a href=""></a>
                    </div>
                  </div>
                </div>

                <div class="tiaozhuan">
                  <!-- <img src="../../static/中层.png" alt=""> -->
                  <div class="centerItem">
                    <img src="../../static/面积.png" alt="" />
                    <span
                      ><h3>30,000</h3>
                      ㎡</span
                    >
                    <span style="text-align: center">{{
                      $t("emailInvite.area")
                    }}</span>
                  </div>
                  <div class="centerItem">
                    <img src="../../static/企业.png" alt="" />
                    <span
                      ><h3>300</h3>
                      {{ $t("emailInvite.home") }}</span
                    >
                    <span style="text-align: center">
                      {{ $t("emailInvite.Domestic") }}</span
                    >
                  </div>
                  <div class="centerItem">
                    <img src="../../static/观众.png" alt="" />
                    <span style="text-align: center"
                      ><h3>50,000</h3>
                      <span> {{ $t("emailInvite.people") }}</span></span
                    >
                    <span style="text-align: center">{{
                      $t("emailInvite.visitors")
                    }}</span>
                  </div>
                  <div class="centerItem">
                    <img src="../../static/地区.png" alt="" />
                    <span
                      ><h3>{{ $t("emailInvite.Multiple") }}</h3>
                      {{ $t("emailInvite.num") }}</span
                    >
                    <span style="text-align: center">{{
                      $t("emailInvite.regions")
                    }}</span>
                  </div>
                </div>
                <p
                  style="
                    margin-top: 20px;
                    font-size: 16px;
                    line-height: 28px;
                    text-indent: 2rem;
                  "
                >
                  {{ $t("emailInvite.content3") }}
                </p>
                <p style="margin-top: 10px; font-size: 16px; line-height: 28px">
                  {{ $t("emailInvite.content3_1") }}
                </p>
                <p style="margin-top: 10px; font-size: 16px; line-height: 28px">
                  {{ $t("emailInvite.content4") }}
                </p>
              </div>

              <div
                style="
                  display: flex;
                  background-color: #ffffff;
                  justify-content: space-around;
                  color: #ffffff;
                  font-size: 16px;
                  font-weight: 400;
                  line-height: 30px;
                  padding: 0 15px;
                  box-sizing: border-box;
                  text-align: center;
                  margin-top: -20px;
                "
              >
                <!-- <div
                  style="width: 128px; height: 30px; background-image: url('../../static/展商.png');"
                >
                  {{ $t("emailInvite.exhibitorList") }}
                </div> -->
                <!-- 原有颜色 0772b9 -->
                <!-- <div
                  style="width: 128px; height: 30px; background-image: url('../../static/展商.png');"
                >
                  {{ $t("emailInvite.exhibits") }}
                </div> -->
                <!-- <div style="width: 128px; height: 30px; background: #0772b9">
                  {{ $t("emailInvite.graph") }}
                </div> -->
                <!-- <div style="width: 128px; height: 30px; background: #0772b9">
                  {{ $t("emailInvite.live") }}
                </div> -->
                <!-- <div style="width: 128px; height: 30px; background: #0772b9">
                  {{ $t("emailInvite.under") }}
                </div> -->
                <div class="navigation-1"></div>
                <div class="navigation-2"></div>
                <div class="navigation-3"></div>
                <div class="navigation-4"></div>
                <div class="navigation-5"></div>
              </div>

              <div
                class="foot"
                style="
                  padding: 50px 25px 40px;
                  font-size: 14px;
                  background: #ffffff;
                "
              >
                <p
                  style="
                    color: #000000;
                    margin-bottom: 5px;
                    font-weight: 600;
                    font-size: 17px;
                  "
                >
                  {{ $t("emailInvite.exhitZixun") }}：
                </p>
                <p style="font-weight: 600; margin-bottom: 5px">
                  {{ $t("connection.name") }}
                </p>
                <div style="font-weight: 600">
                  <p style="margin-bottom: 5px">
                    {{ $t("special.linkman") }}：{{ $t("emailInvite.person") }}
                  </p>
                  <p style="margin-bottom: 20px">
                    {{ $t("special.telephone") }}：010-64253601
                  </p>
                  <p>E-mail：chinaminexpo@vip.163.com</p>
                </div>
              </div>
              <div class="footerImg">
                <img
                  src="../../static/EmailFooter.png"
                  alt=""
                  srcset=""
                  style="width: 650px"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="right">
          <!--          <el-button @click="createPoster">test</el-button>-->
          <p class="title">
            {{ $t("emailInvite.inputEmail") }} <br />
            {{ $t("emailInvite.inviteTa") }}
          </p>
          <p class="name">
            {{ $t("emailInvite.exName") }}
          </p>
          <span> {{ $t("homepage.positionNumber") }}： </span>
          <el-select v-model="value" :placeholder="$t('card.placeholder4')">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-input
            v-model="email"
            :rows="8"
            maxlength="100"
            type="textarea"
            :placeholder="$t('emailInvite.content5')"
          ></el-input>
          <el-button @click="submit"> {{ $t("dialog.submit") }}</el-button>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import html2canvas from "html2canvas";
import QRCode from "qrcodejs2";
import { forMat } from "../../../utils/common";
import { getExhition } from "../../../api/exhibitor";

import { getBooth } from "../../../api/exhibitor.js";
import { sendEmail } from "../../../api/email.js";

export default {
  name: "emailInvite",
  data() {
    return {
      posterUrl: "",
      img: "../../static/logo.png",
      companyName: "中国煤炭工业国际咨询有限责任公司",
      locationl: "xxx",
      isshow: true, //判断海报是否生成
      email: "", //文本域
      options: [],
      value: "",
      baseUrl: forMat(),
    };
  },
  created() {
    this.getBoothList();
    this.getExhition();

    // this.$nextTick(function () {
    //   this.createPoster();
    // })
  },
  methods: {
    async getBoothList() {
      try {
        let { data } = await getBooth();
        if (data.code === 200) {
          // this.$message({
          //   type: 'success',
          //   message: '获取展位列表成功!',
          // });

          data.data.map((item) => {
            this.options.push({
              value: item.id,
              label: item.boothNum,
            });
          });
        }
      } catch (e) {
        this.$message.error(e);
      }
    },
    async getExhition() {
      try {
        let { data } = await getExhition();
        this.companyName = data.data.companyNameC;

        this.img =
          data.data.comCover.indexOf("http") > -1
            ? data.data.comCover
            : forMat() + data.data.comCover;
        console.log("展商的Logo:", this.img);
        // console.log("展商的展位号:",this.companyName);
        this.$nextTick(function () {
          this.createPoster();
        });
        // console.log('展商信息',data)
      } catch (e) {
        this.$message.error(e);
      }
    },
    //生成海报
    createPoster() {
      const vm = this;
      const email = document.getElementById("email");
      html2canvas(email, {
        useCORS: true,
        allowTaint: false,
        logging: false,
        letterRendering: true,
        scale: 1, //放大
        x: vm.getActuralPosition(email).left,
        y: vm.getActuralPosition(email).top,
        // onclone(doc) {
        //   let backimg = doc.querySelector('#email')
        //   console.log(backimg)
        //   backimg.style.display='block';
        // }
      }).then(function (canvas) {
        vm.posterUrl = canvas.toDataURL("image/png");
        vm.isshow = false;
      });
    },

    //获取元素绝对位置
    getActuralPosition(element) {
      let acturalLeft = element.offsetLeft;
      let acturalTop = element.offsetTop;
      let curElement = element.offsetParent;
      while (curElement) {
        acturalLeft += curElement.offsetLeft;
        acturalTop += curElement.offsetTop;
        curElement = curElement.offsetParent;
      }
      return {
        left: acturalLeft,
        top: acturalTop,
      };
    },
    //文本域方法
    ctxt() {},
    async submit() {
      const arr = this.email.split("\n");
      const params = {
        boothId: this.value,
        mailList: arr,
      };
      try {
        const { data } = await sendEmail(params);
        if (data.code === 200) {
          this.$message({
            type: "success",
            message: "邮件发送成功!",
          });
          this.value = "";
          this.email = "";
        }
      } catch (err) {
        this.$message.error(err);
      }
    },
  },
};
</script>
<style scoped>
.company {
  display: flex;
  height: 200px;
  box-sizing: border-box;
  padding: 18px 14px 29px 27px;
}
.company .companyimg {
  width: 35%;
  padding-right: 31px;
  border-right: 1px solid #939598;
  display: flex;
  align-items: center;
  justify-content: center;
}
.companyimg img {
  width: 100%;
  /* min-height: 100%; */
}
.companyName {
  margin-left: 20px;
  height: 153px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.companyName h3 {
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 28px;
  margin-bottom: 15px;
}
.xinguan-copy {
  width: 600px;
  height: 80px;
  background: linear-gradient(0deg, #ffe53f 0%, #facd00 60%);
  display: flex;
  position: relative;
}
.xinguan {
  width: 600px;
  height: 80px;
  display: flex;
  position: relative;
}
.pavilion {
  width: 354px;
  box-sizing: border-box;
  padding: 15px 0 20px 25px;
  font-size: 16px;
  font-weight: 500;
  color: #0772b9;
}
.exhi {
  width: 76px;
  text-align: center;
  background: #ffde17;
  color: #0772b9;
  color: #0772b9;
}
.exhi p {
  margin-top: 21px;
}

.exhiNum {
  font-size: 38px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #0772b9;
  line-height: 28px;
  text-align: center;
  padding: 17px 35px;
}
.subscribe {
  position: absolute;
  width: 320px;
  height: 80px;
  top: 0;
  left: 168px;
  text-align: center;
  line-height: 50px;
  background-image: url("../../static/立即预约.png");
  background-size: cover;
}
.subscribe-copy {
  position: absolute;
  width: 240px;
  height: 50px;
  border-radius: 20px;
  top: 0;
  left: 168px;
  text-align: center;
  line-height: 50px;
  background: linear-gradient(0deg, #0772b9 0%, #0772b9 100%);
}
.subscribe a {
  text-decoration: none;
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 28px;
}
.tiaozhuan {
  display: flex;
  margin-top: 115px;
  margin-left: -22px;
  width: 650px;
  height: 150px;
  flex-direction: row !important;
  align-items: space-around;
  background-image: url("../../static/中层.png");
}
.navigation-1 {
  width: 110px;
  height: 55px;
  background-image: url("../../static/展商.png");
  background-size: cover;
}
.navigation-2 {
  width: 110px;
  height: 55px;
  background-image: url("../../static/展品.png");
  background-size: cover;
}

.navigation-3 {
  width: 110px;
  height: 55px;
  background-image: url("../../static/展位.png");
  background-size: cover;
}

.navigation-4 {
  width: 110px;
  height: 55px;
  background-image: url("../../static/直播.png");
  background-size: cover;
}
.navigation-5 {
  width: 110px;
  height: 55px;
  background-image: url("../../static/了解.png");
  background-size: cover;
}
.tiaozhuan .centerItem {
  display: flex;
  width: 162.5px;
  height: 150px;
  flex-direction: column !important;
  justify-content: center;
  align-items: center;
  position: relative;
  color: white;
}
.tiaozhuan .centerItem h3 {
  color: #ffde17;
  font-weight: 600;
  display: inline;
  margin: 20px 3px 20px 0;
}
.tiaozhuan .centerItem img {
  width: 33px;
  height: 37px;
  position: relative;
  margin-bottom: 3px;
}
.footerImg img {
  width: 650px;
  height: 200px;
}
.link1 {
  flex: 1;
  text-align: center;
  border-right: 2px solid #939598;
}
.link1 a {
  text-decoration: none;
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #0772b9;
  line-height: 28px;
}
</style>

<style lang="scss" scoped>
.body {
  //margin: 20px 30px 20px 30px;
  font-family: PingFangSC-Regular, PingFang SC;

  .header {
    padding: 0 0 20px 30px;
    border-bottom: 1px solid #e8e8e8;

    h3 {
      font-size: 20px;
      font-weight: 500;
      color: #333333;
      line-height: 28px;
      font-family: PingFangSC-Medium, PingFang SC;
    }
  }

  .main {
    //border: 1px solid red;
    margin: 40px 114px;
    display: flex;

    .left {
      .email {
        width: 714px;
        //height: 1430px;
        padding: 30px 32px;
        box-sizing: border-box;
        background: #f6f6f7;
        font-family: PingFang SC;
        color: #333333;

        .head {
          background: #0772b9; //原white
          height: 180px; //原326
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          img {
            width: 650px;
            // height: 111px;
          }

          p {
            font-size: 16px;
            color: #fefeff;
            margin-top: 10px;
          }
        }

        .content {
          padding: 30px 25px 40px;
          background: #ffffff;

          .logo {
            display: flex;
            justify-content: space-between;
            img {
              width: 150px;
            }

            p {
              text-align: right;
              font-size: 18px;
              font-weight: 600;
              color: #0772b9;
              line-height: 20px;
            }
          }
        }
      }
    }

    .right {
      margin-top: 196px;
      margin-left: 152px;

      .title {
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 25px;
      }

      .name {
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #0772b9;
        line-height: 28px;
        margin-bottom: 58px;
        margin-top: 20px;
      }
    }
  }
}
</style>

<style scoped>
.el-select >>> .el-input__inner {
  width: 430px !important;
}
.el-textarea >>> .el-textarea__inner {
  width: 500px;
  margin-top: 10px;
}
>>> .el-card__body {
  padding: 20px 0;
}

>>> .el-button {
  background-color: #006fb8;
  color: #ffffff;
  width: 102px;
  height: 32px;
  padding: 0;
  font-weight: 400;
  margin-top: 30px;
}
</style>
